module.exports = __webpack_public_path__ + "static/media/cq_cellulare.96983284.svg";